import { Component, createElement, Fragment, type ReactNode } from 'react';

/**
 * Around a client's Documents (21 October, 16:50): a crash inside shows "Something went wrong showing this folder"
 * and "Back to Documents", never a blank page. Before it, one throw in the panel (a selector built from a folder's
 * key) unmounted the whole application. Back to Documents mounts the panel afresh, at the top level. Written with
 * createElement, not JSX, so web/test/documents-boundary.test.ts can load it under node.
 */
interface State { failed: boolean; attempt: number }

export class DocumentsBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false, attempt: 0 };

  static getDerivedStateFromError(): Partial<State> {
    return { failed: true };
  }

  /** After a crash: shown again from the top (a new key mounts the panel afresh, so its path starts empty). */
  static reset(s: State): State {
    return { failed: false, attempt: s.attempt + 1 };
  }

  back = () => this.setState(DocumentsBoundary.reset);

  render() {
    if (!this.state.failed) return createElement(Fragment, { key: this.state.attempt }, this.props.children);
    return createElement('section', { className: 'panel px-4 py-4', role: 'alert' },
      createElement('p', { className: 'font-semibold' }, 'Something went wrong showing this folder.'),
      createElement('button', {
        type: 'button', onClick: this.back,
        className: 'mt-3 inline-flex min-h-[44px] items-center rounded-lg bg-brand px-4 font-semibold text-on-brand',
      }, 'Back to Documents'));
  }
}
